<template>
  <el-form
    :form="form"
  >
    <div class="row">
      <div class="col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('employee')"
            prop="employeeID"
            class="material-style"
          >
            <select-response
              :model.sync="form.employeeID"
              :data="dataSourceEmployee.records"
              @on-change="onFilter"
            ></select-response>
          </el-form-item>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('date')"
          prop="date"
          class="material-style"
        >
          <date-picker
            v-model="form.date"
            @change="onFilter"
          ></date-picker>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'ToolsPanel',
  mounted () {
    this.onFilter()
  },
  data () {
    return {
      form: {
        employeeID: null,
        date: new Date()
      }
    }
  },
  computed: {
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title')
    }
  },
  methods: {
    getFilterData () {
      return {
        ...this.form,
        date: this.$moment(this.form.date).format('YYYY,MM,DD')
      }
    },
    onFilter () {
      this.$emit('onFilter', this.getFilterData())
    }
  }
}
</script>

<style>

</style>
